import { useState } from "react";
import makeStyles from '@mui/styles/makeStyles';
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ApplicationBar, {
  toolbarHeight,
} from "./../../Components/ApplicationBar";

import NavigationDrawer from "./../../Components/NavigationDrawer";
import MainTabs from "../../Components/MainTabs";
import Footer from "../../Components/Footer";

import { useSelector } from "react-redux";
import { contactSelector } from "../../../../store/userSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
    marginTop: toolbarHeight,
    marginBottom: toolbarHeight,
    height: `calc(100vh - ${toolbarHeight * 2}px)`,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
  mainPaper: {
    padding: theme.spacing(2),
    display: "flex",
    height: `calc(100vh - ${toolbarHeight * 2 + 150}px)`,
    overflow: "auto",
    flexDirection: "column",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
}));

export default function MainLayout({ children, navigation, baseurl }) {
  const classes = useStyles();
  const [menuOpen, setMenuOpen] = useState(true);
  const contact = useSelector(contactSelector);

  const setOpen = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <ApplicationBar setOpen={setOpen} />
      <NavigationDrawer
        userName={contact?.displayname}
        open={menuOpen}
        navigation={navigation}
      />
      <main className={classes.content}>
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MainTabs baseurl={baseurl} />
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.mainPaper}>{children}</Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
